module.exports = __webpack_public_path__ + "img/Apachelogo.19e690dc.png";